export default "__VITE_ASSET__0ce8c174__"